import cx from 'clsx';
import styles from './status-screen.module.css';

export function StatusScreen({
  title,
  subtitle,
  illustration,
  cta,
}: {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  illustration: React.ReactNode;
  cta?: React.ReactNode;
}) {
  return (
    <div className={styles.container}>
      <figure className={styles.illustration}>{illustration}</figure>

      <h1 className="heading-page mb-16" data-test-title>
        {title}
      </h1>

      <p className={cx('body-standard', Boolean(cta) && 'mb-32')} data-test-subtitle>
        {subtitle}
      </p>

      <div className={styles.cta}>{cta}</div>
    </div>
  );
}
